module.exports = __webpack_public_path__ + "static/media/img-whatelse_off.9ba2ae91.svg";